<template>
    <div>
        <b-row>
            <b-col sm="12" md="4" lg="4" xl="3" v-if="mostrarFiltroNomeConvenio">
                <b-form-group>
                    <label>Convênio</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            placeholder="Digite o número do convênio"
                            v-model="convenio"
                            v-mask="'CV###/##'"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3" lg="3" xl="3" v-if="mostrarFiltroDatasInicioFim">
                <b-form-group>
                    <label>Data Início</label>
                    <date-picker 
                        v-model="dataInicio" 
                        :config="$datePickerOptions" 
                        v-mask="'##/##/####'">
                    </date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3" lg="3" xl="3" v-if="mostrarFiltroDatasInicioFim">
                <b-form-group>
                    <label>Data Fim</label>
                    <date-picker 
                        v-model="dataFim" 
                        :config="$datePickerOptions" 
                        v-mask="'##/##/####'">
                    </date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="10" md="2" lg="2" xl="2" v-if="mostrarFiltroCompetencia">
                <b-form-group>
                    <label>Data Competência</label>
                    <date-picker 
                        v-model="dataCompetencia" 
                        :config="$monthPickerOptions" 
                        v-mask="'##/####'">
                    </date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" v-if="mostrarFiltroApenasAtivos">
                <b-form-group>
                    <b-checkbox 
                        v-model="apenasAtivos" 
                        class="mt-4 pt-2">
                        Apenas Convênios Ativos
                    </b-checkbox>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        tiposFiltros: {
            type: String
        }
    },

    data() {
        return {
            convenio: null,
            dataInicio: null,
            dataFim: null,
            dataCompetencia: null,
            apenasAtivos: false,
        }
    },

    computed: {
        filtro() {
            let retorno = 
            {
                dataInicio: this.dataInicio ? this.$moment(this.dataInicio, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                dataFim: this.dataFim ? this.$moment(this.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                dataCompetencia: this.dataCompetencia ? this.$moment(this.dataCompetencia, 'MM/YYYY').format('YYYY-MM-DD') : null,
                apenasAtivos: this.apenasAtivos,
                convenio: this.convenio
            }
            return retorno
        },
        

        mostrarFiltroDatasInicioFim() {
            if (this.tiposFiltros && this.tiposFiltros.includes('i')) {
                return true
            }
            return false
        },
        mostrarFiltroCompetencia() {
            if (this.tiposFiltros && this.tiposFiltros.includes('c')) {
                return true
            }
            return false
        },

        mostrarFiltroApenasAtivos() {
            if (this.tiposFiltros && this.tiposFiltros.includes('a')) {
                return true
            }
            return false
        },

        mostrarFiltroNomeConvenio() {
            if (this.tiposFiltros && this.tiposFiltros.includes('n')) {
                return true
            }
            return false
        },
    },

    watch: {
        dataInicio() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataFim() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataCompetencia() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        apenasAtivos() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        convenio() {
            this.$emit('filtroAtualizado', this.filtro)
        }
    }
}
</script>
